type ImportMetaWithEnv = ImportMeta & {
	env: Record<string, string | undefined>;
};

function getImportMetaEnv(): Record<string, string | undefined> | undefined {
	if (typeof import.meta !== "undefined") {
		return (import.meta as ImportMetaWithEnv).env;
	}
	return undefined;
}

function getEnvSource() {
	const isBrowser = typeof window !== "undefined";
	if (isBrowser) {
		return getImportMetaEnv();
	}
	// サーバー側での安全なアクセス
	return typeof process !== "undefined" && process.env ? process.env : {};
}

export function getEnvVar(key: string, fallback?: string) {
	const value = getEnvSource()?.[key];
	if (value && value.length > 0) {
		return value;
	}
	if (fallback) {
		return fallback;
	}
	return undefined;
}

export function getRuntimeEnv() {
	if (typeof window !== "undefined" && window.__ENV__) {
		return window.__ENV__;
	}
	return getEnvVar("ENV") || getEnvVar("VITE_ENV") || "dev";
}

declare global {
	interface Window {
		__ENTERPRISE_API_URL__?: string;
		__WEBHOOK_URL__?: string;
		__ENV__?: string;
	}
}

export function getEnterpriseApiBaseUrl() {
	// クライアント側: SSRで埋め込まれたAPI URLを優先
	if (typeof window !== "undefined" && window.__ENTERPRISE_API_URL__) {
		return window.__ENTERPRISE_API_URL__;
	}

	// APIのベースURLを取得（環境変数またはデフォルト値）
	const url = getEnvVar("API_URL") || getEnvVar("VITE_API_URL");

	// 環境変数が設定されていない場合、現在のオリジンを使用（プロキシ経由）
	if (!url) {
		if (typeof window !== "undefined") {
			// クライアント側: 現在のオリジンを使用
			console.warn("[ENV] API_URL not set, using current origin:", window.location.origin);
			return window.location.origin;
		}
		// サーバー側: localhost:8081を使用 (Enterprise REST API port)
		return "http://localhost:8081";
	}

	return url;
}

export function getWebhookUrl() {
	if (typeof window !== "undefined" && window.__WEBHOOK_URL__) {
		return window.__WEBHOOK_URL__;
	}
	return getEnvVar("WEBHOOK_URL") || "http://localhost:8080";
}

export function getRuntimeMode() {
	return getEnvVar("MODE") || getEnvVar("NODE_ENV") || "development";
}

export function isProduction() {
	const mode = getRuntimeMode();
	return mode === "production";
}

export function isDevelopment() {
	const mode = getRuntimeMode();
	return mode === "development" || mode === "dev";
}
